'use strict';

class _User {
  _id = '';
  name = '';
  email = '';
  role = '';
  $promise = undefined;
}

export function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
  'ngInject';

  var safeCb = Util.safeCb;
  var currentUserResult = new _User();
  var currentUser = new Promise((resolve, reject) => {
    console.log("currentUserResult", currentUserResult);
    return resolve(currentUserResult);
  });
  var userRoles = appConfig.userRoles || [];
  /**
   * Check if userRole is >= role
   * @param {String} userRole - role of current user
   * @param {String} role - role to check against
   */
  var hasRole = function(userRole, role) {
    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
  };

  var Auth = {
    /**
     * Gets all available info on a user
     *
     * @param  {Function} [callback] - function(user)
     * @return {Promise}
     */
    getCurrentUser(callback) {
      // var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;

      // return $q.when(value)
      return currentUser
        .then(user => {
          safeCb(callback)(user);
          return user;
        }, () => {
          safeCb(callback)({});
          return {};
        });
    },

    /**
     * Gets all available info on a user
     *
     * @return {Object}
     */
    getCurrentUserSync() {
      return currentUserResult;
    },

    /**
     * Check if a user is logged in
     *
     * @param  {Function} [callback] - function(is)
     * @return {Promise}
     */
    isLoggedIn(callback) {
      return Auth.getCurrentUser(undefined)
        .then(user => {
          let is = _.get(user, 'role');

          safeCb(callback)(is);
          return is;
        });
    },

    /**
     * Check if a user has a specified role or higher
     *
     * @param  {String}     role     - the role to check against
     * @param  {Function} [callback] - function(has)
     * @return {Promise}
     */
    hasRole(role, callback) {
      return Auth.getCurrentUser(undefined)
        .then(user => {
          let has = hasRole(_.get(user, 'role'), role);

          safeCb(callback)(has);
          return has;
        });
    },

    /**
     * Get auth token
     *
     * @return {String} - a token string used for authenticating
     */
    getToken() {
      return $cookies.get('token');
    },

    updateUser(){
      currentUser = User.get().$promise
        .then((user) => {
          currentUserResult = user;
          return user;
        });
      return currentUser;
    },

    setToken(token) {
      $cookies.put('token', token);
      return Auth.updateUser();
    },
  };

  if($location.search().access_token){
    currentUser = $http.post('/auth/token', {}, {
      params: {
        access_token: $location.search().access_token,
      },
    })
      .then(res => {
        $cookies.put('token', res.data.token);
        $location.search('access_token', null);
        return Auth.updateUser();
      });
  }else if($cookies.get('token') && $location.path() !== '/logout') {
    Auth.updateUser();
  }

  return Auth;
}
